<section class="admin-history">
  <div class="admin-history__header">
    <div>
      <h2 class="admin-history__title">
        {{ "COMPONENTS.ADMIN_PANEL.ACCESS_HISTORY.TITLE" | translate }}
      </h2>
      <p class="admin-history__subtitle">
        {{ "COMPONENTS.ADMIN_PANEL.ACCESS_HISTORY.SUBTITLE" | translate }}
      </p>
    </div>
  </div>

  <div class="admin-history__filters">
    <div class="admin-history__field">
      <label class="admin-history__label" for="audit-email-filter">
        {{ "COMPONENTS.ADMIN_PANEL.ACCESS_HISTORY.EMAIL_LABEL" | translate }}
      </label>
      <input
        id="audit-email-filter"
        type="text"
        class="input-field-lg"
        [formControl]="emailControl"
        [placeholder]="'COMPONENTS.ADMIN_PANEL.ACCESS_HISTORY.EMAIL_PLACEHOLDER' | translate"
      />
    </div>

    <div class="admin-history__field">
      <label class="admin-history__label" for="audit-date-from-filter">
        {{ "COMPONENTS.ADMIN_PANEL.ACCESS_HISTORY.DATE_FROM_LABEL" | translate }}
      </label>
      <input
        id="audit-date-from-filter"
        type="date"
        class="input-field-lg"
        [formControl]="dateFromControl"
      />
    </div>

    <div class="admin-history__field">
      <label class="admin-history__label" for="audit-date-to-filter">
        {{ "COMPONENTS.ADMIN_PANEL.ACCESS_HISTORY.DATE_TO_LABEL" | translate }}
      </label>
      <input
        id="audit-date-to-filter"
        type="date"
        class="input-field-lg"
        [formControl]="dateToControl"
      />
    </div>

    <div class="admin-history__actions">
      <button type="button" class="btn-primary" (click)="applyFilters()">
        {{ "BUTTONS.SEARCH" | translate }}
      </button>
      <button type="button" class="btn-secondary" (click)="clearFilters()">
        {{ "BUTTONS.RESET" | translate }}
      </button>
    </div>
  </div>

  @if (isLoading) {
    <p class="admin-history__empty">
      {{ "MESSAGES.LOADING" | translate }}
    </p>
  } @else if (auditEvents.length > 0) {
    <div class="admin-audit-list">
      @for (event of auditEvents; track event.id) {
        <article class="admin-audit-list__item">
          <div class="admin-audit-list__topline">
            <div class="admin-audit-list__summary">
              <h3 class="admin-audit-list__title">{{ event.eventType }}</h3>
              <p class="admin-audit-list__meta">
                {{ event.companyName || event.initiatorEmail || ("COMPONENTS.COMPANIES.AUDIT_UNKNOWN" | translate) }}
              </p>
            </div>
            <time class="admin-audit-list__time">
              {{ event.createdAt | date: 'medium' }}
            </time>
          </div>

          @if (event.initiatorEmail || event.targetUserEmail) {
            <p class="admin-audit-list__detail">
              {{ event.initiatorEmail || ("COMPONENTS.COMPANIES.AUDIT_UNKNOWN" | translate) }}
              @if (event.targetUserEmail) {
                <span class="admin-audit-list__detail-separator">-&gt;</span>
                {{ event.targetUserEmail }}
              }
            </p>
          }

          @if (event.path) {
            <p class="admin-audit-list__path">{{ event.path }}</p>
          }
        </article>
      }
    </div>
  } @else {
    <p class="admin-history__empty">
      {{ "COMPONENTS.COMPANIES.AUDIT_HISTORY_EMPTY" | translate }}
    </p>
  }
</section>
